import {
  createSerializationOptionsForEnumValue,
  useSearchParamState,
} from 'utils/hooks/useSearchParamState';
import { STOMessageMediumTabs } from 'modules/intelligentInsights/stoInsights/types';

export const useSTOInsightsSearchParams = () => {
  const [selectedTab, setSelectedTab] = useSearchParamState({
    searchParamKey: 'stoTab',
    stateValueWhenSearchParamIsUnset: STOMessageMediumTabs.Email,
    ...createSerializationOptionsForEnumValue({
      enumKeyValueMap: STOMessageMediumTabs,
      stateValueWhenSearchParamIsInvalid: STOMessageMediumTabs.Email,
    }),
  });

  const wrappedSetSelectedTab = (value: STOMessageMediumTabs) => {
    setSelectedTab(value);
  };

  return {
    selectedTab,
    setSelectedTab: wrappedSetSelectedTab,
  };
};
